module.exports = __webpack_public_path__ + "img/skinner-1-r.e5414dc5.png";